import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { ClientExerciseTracingTypeEnum } from '@client/shared/models/therapy-plan/client-exercise-tracing-type.enum';

@Injectable({ providedIn: 'root' })
export class ClientExerciseTracingApiService {

  readonly #http = inject(HttpClient);

  private get endpoint() {
    return `${environment.basePath}/therapy-plan/exercise/tracing`;
  }

  createTherapyPlanExerciseTracing(therapyPlanExerciseId: string, tracingType: ClientExerciseTracingTypeEnum): Observable<any> {
    return this.#http.post<any>(`${this.endpoint}/${therapyPlanExerciseId}`, { tracingType: tracingType });
  }

  /**
   * @param therapyPlanId
   *
   * @returns a Dict where key is the id of the exercise and the value, if the exercise has been watched.
   */
  getTherapyPlanExerciseTracingsIsExplanationWatched(therapyPlanId: string): Observable<Record<string, boolean>> {
    return this.#http.get<Record<string, boolean>>(`${this.endpoint}/${therapyPlanId}/is-explanation-watched`);
  }
}
